import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getBanks } from 'actions/linkBank';
import { selectAutosaveStatusObj } from 'reducers/selectors';
import { assertUnreachable } from 'utils';
import { useMainStackNavigation } from 'utils/types/navigationV6';
export const useNavigateToFixAutosave = (actionRequired) => {
    const navigation = useMainStackNavigation();
    const dispatch = useAppDispatch();
    const allBanks = useAppSelector((state) => state.linkBank.banks);
    const autosaveStatusObj = useAppSelector(selectAutosaveStatusObj);
    const bankId = useAppSelector((state) => state.pots.savingsPlan?.bankId);
    useEffect(() => {
        if (!allBanks.length)
            dispatch(getBanks());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const navigateToFixAutosave = useCallback(() => {
        if (actionRequired) {
            switch (actionRequired) {
                case 'DELETED':
                    if (bankId) {
                        const data = allBanks.find((bank) => bank.id === bankId);
                        if (data) {
                            navigation.navigate('Consent', {
                                data,
                                showConnectScreen: false,
                            });
                        }
                    }
                    break;
                case 'CLOSED':
                    if (autosaveStatusObj?.account?.bankConnectionId) {
                        navigation.navigate('ClosedAccounts', {
                            connectionId: autosaveStatusObj?.account?.bankConnectionId,
                        });
                    }
                    break;
                case 'DIRECT_DEBIT_CANCELLED':
                case 'DIRECT_DEBIT_ACCOUNT_CHANGED':
                    navigation.navigate('AutosaveSelectBank');
                    break;
                case 'NEEDS_RECONSENT':
                case 'NEEDS_REAUTH':
                    navigation.navigate('BrokenConnections');
                    break;
                case 'CONNECTION_CLOSED':
                case 'DEACTIVATED_OVER_QUOTA':
                    if (autosaveStatusObj?.account?.bankConnectionId) {
                        navigation.navigate('BankConnection', {
                            connectionId: autosaveStatusObj?.account?.bankConnectionId,
                        });
                    }
                    break;
                case 'REMOVED':
                    navigation.navigate('Support');
                    break;
                case 'DESTINATIONS_UNAVAILABLE':
                    navigation.navigate('AutosaveDistribution', { isEditFlow: true });
                    break;
                default:
                    assertUnreachable(actionRequired);
                    break;
            }
        }
    }, [actionRequired, allBanks, autosaveStatusObj?.account?.bankConnectionId, bankId]);
    return navigateToFixAutosave;
};
